import { Box, Divider, Stack, Typography } from '@mui/material';
import formatDateTime from '@product-framework/utils/formatDateTime';
import ReadMoreText from '@ui-framework/components/UI/ReadMoreText';
import MultiValueDisplay from '@ui-framework/helpers/MultiValueDisplay';
import { IconLibrary } from '@product-framework/index';
import { FormattedMessage } from 'react-intl';
import { IconChip } from '@product-framework/components/PageSection';
import fetchAcceptedWithConditions from '../../../lib/fetchAcceptedWithConditions';

function AssignedWithConditions({ sp }) {
  return (
    <Box>
      <Stack
        direction="row"
        spacing={0.5}
        sx={{ alignItems: 'center', justifyContent: 'left' }}>
        <IconChip
          bgColor="primary.light"
          iconColor="primary.main"
          Icon={IconLibrary.ConditionllyAcceptServiceJob}
          size={30}
          iconFontSize="18px"
        />
        <Typography variant="subtitle2" color="text.secondary">
          <FormattedMessage
            id="CONDITIONS_FOR_ACCEPTANCE"
            defaultMessage="Conditions for Acceptance"
          />
        </Typography>
      </Stack>
      <Box>
        {fetchAcceptedWithConditions({
          ReadMoreText,
          MultiValueDisplay,
          formatDateTime,
          sp,
          currencyColor: '#000000',
        })}
      </Box>
      <Divider />
    </Box>
  );
}

export default AssignedWithConditions;
